import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const getBookingGroupSizeAtom = atom((get) => {
  const booking = get(currentBookingAtom);
  return booking?.rounds.filter((r) => !r.isNonPlayingHost).length ?? null;
});
